$(document).ready(function(){

    /* Input plus minus */
    $(document).on( 'click', '.quantity .quantity_minus', function(){
        let input = $(this).parents('.quantity').children('input[type="number"]');
        let newVal = (input.val()-1);
        let inputMin  = input.attr('min');
        let inputMax  = input.attr('max');

        if(inputMax && newVal > inputMax){
            newVal = inputMax;
        }
        if(newVal >= inputMin){
            input.val(newVal).change();
        }
        if(newVal <= inputMin){
            $(this).addClass('disabled');
        }

    })

    $(document).on( 'click', '.quantity .quantity_plus', function(){
        let input = $(this).parents('.quantity').children('input[type="number"]');
        let newVal = parseInt(input.val())+1;
        let inputMax = input.attr('max');

        if(!inputMax || newVal <= inputMax){
            input.val(newVal).change();
            $('.quantity_minus.disabled').removeClass('disabled');
        }else{
            input.val(inputMax);
            notif('danger', $(input).attr('data-max-text'));
        }
    });
});
